import { render, staticRenderFns } from "./StudentEditCourseSlidebar.vue?vue&type=template&id=0a30ebf0"
import script from "./StudentEditCourseSlidebar.vue?vue&type=script&lang=js"
export * from "./StudentEditCourseSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports